export const normalizeDropdownSelectionToArray = (selectionOrList) => {
  if (Array.isArray(selectionOrList)) {
    return selectionOrList;
  }

  if (selectionOrList) {
    return [selectionOrList];
  }

  return [];
};
